var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "19px",
    viewBox: "0 0 22 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FF7BDCB6-FCDC-4008-98A9-476AC81D988C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1442.000000, -1723.000000)",
    fill: "#677283",
    fillRule: "nonzero",
    id: "Icon/Warning"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1442.000000, 1723.000000)",
    id: "Warning"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,19 L11,0 L22,19 L0,19 Z M10,13 L12,13 L12,8 L10,8 L10,13 Z M11,16 C11.2833333,16 11.521,15.904 11.713,15.712 C11.9043333,15.5206667 12,15.2833333 12,15 C12,14.7166667 11.9043333,14.4793333 11.713,14.288 C11.521,14.096 11.2833333,14 11,14 C10.7166667,14 10.4793333,14.096 10.288,14.288 C10.096,14.4793333 10,14.7166667 10,15 C10,15.2833333 10.096,15.5206667 10.288,15.712 C10.4793333,15.904 10.7166667,16 11,16 Z M3.45,17 L18.55,17 L11,4 L3.45,17 Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.c215c71d.svg";
export { ForwardRef as ReactComponent };